import { SurveyCreatorComponent, SurveyCreator } from "survey-creator-react";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { useContext, useEffect, useRef, useState } from "react";
import { Box, Button, Card, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer, TextareaAutosize } from "@mui/material";
// import { Survey } from "survey-react-ui";
// import { Serializer } from "survey-core";
import 'survey-core/defaultV2.min.css';
import { IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonLoading, IonPage, IonText, IonTitle, IonToolbar } from "@ionic/react";
import "./index.css";
import { Serializer, setLicenseKey } from "survey-core";
import { useLocation } from "react-router";
import Header from "../Header/Header";
import { width } from "@mui/system";
import * as ApiService from "../../services/ApiService";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import { arrowBackCircleSharp } from "ionicons/icons";
import { useHistory } from "react-router";
import { Icon } from "@iconify/react";
import React from "react";
import * as Helpers from "../../services/Helpers";
import saveAs from "save-as";
import { useTranslations } from "../../hooks/useTranslations";
import "survey-creator-core/survey-creator-core.i18n";
import "survey-creator-core/i18n/spanish";

var _ = require("lodash");

const customTheme = {
    "cssVariables": {
        "--sjs-primary-backcolor": "#2772cb",
        // "--sjs-question-background": "black",
        // "color": "red",
        // "--sjs-editor-background": "red",
        // "--sjs-editorpanel-backcolor": "blue",
        "--sjs-font-editorfont-color": "white", //text color
    },
}

export const themeJson = {
    "themeName": "flat",
    "colorPalette": "light",
    "isPanelless": false,
    // "backgroundImageFit": "contain",
    // "backgroundImage": "",
    "backgroundOpacity": 1,
    // "backgroundImageAttachment": "scroll",
    "cssVariables": {
        "--sjs-corner-radius": "6px",
        "--sjs-base-unit": "7.2px",
        "--sjs-shadow-small": "0px 0px 0px 1px rgba(0, 0, 0, 0.15)",
        "--sjs-shadow-inner": "0px 0px 0px 1px rgba(0, 0, 0, 0.12)",
        "--sjs-border-default": "rgba(0, 0, 0, 0.12)",
        "--sjs-border-light": "rgba(0, 0, 0, 0.12)",
        "--sjs-general-backcolor": "rgba(246, 246, 246, 1)",
        "--sjs-general-backcolor-dark": "rgba(235, 235, 235, 1)",
        "--sjs-general-backcolor-dim-light": "rgba(255, 255, 255, 1)",
        "--sjs-general-backcolor-dim-dark": "rgba(235, 235, 235, 1)",
        "--sjs-general-forecolor": "rgba(0, 0, 0, 0.91)",
        "--sjs-general-forecolor-light": "rgba(0, 0, 0, 0.45)",
        "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
        "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
        "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
        "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
        "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
        "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
        "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.15)",
        "--sjs-shadow-medium": "0px 0px 0px 1px rgba(0, 0, 0, 0.1),0px 2px 6px 0px rgba(0, 0, 0, 0.1)",
        "--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
        "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.12)",
        "--sjs-border-inside": "rgba(0, 0, 0, 0.16)",
        "--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-green": "rgba(25, 179, 148, 1)",
        "--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
        "--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-blue": "rgba(67, 127, 217, 1)",
        "--sjs-special-blue-light": "rgba(67, 127, 217, 0.1)",
        "--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
        "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
        "--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-article-font-xx-large-textDecoration": "none",
        "--sjs-article-font-xx-large-fontWeight": "700",
        "--sjs-article-font-xx-large-fontStyle": "normal",
        "--sjs-article-font-xx-large-fontStretch": "normal",
        "--sjs-article-font-xx-large-letterSpacing": "0",
        "--sjs-article-font-xx-large-lineHeight": "64px",
        "--sjs-article-font-xx-large-paragraphIndent": "0px",
        "--sjs-article-font-xx-large-textCase": "none",
        "--sjs-article-font-x-large-textDecoration": "none",
        "--sjs-article-font-x-large-fontWeight": "700",
        "--sjs-article-font-x-large-fontStyle": "normal",
        "--sjs-article-font-x-large-fontStretch": "normal",
        "--sjs-article-font-x-large-letterSpacing": "0",
        "--sjs-article-font-x-large-lineHeight": "56px",
        "--sjs-article-font-x-large-paragraphIndent": "0px",
        "--sjs-article-font-x-large-textCase": "none",
        "--sjs-article-font-large-textDecoration": "none",
        "--sjs-article-font-large-fontWeight": "700",
        "--sjs-article-font-large-fontStyle": "normal",
        "--sjs-article-font-large-fontStretch": "normal",
        "--sjs-article-font-large-letterSpacing": "0",
        "--sjs-article-font-large-lineHeight": "40px",
        "--sjs-article-font-large-paragraphIndent": "0px",
        "--sjs-article-font-large-textCase": "none",
        "--sjs-article-font-medium-textDecoration": "none",
        "--sjs-article-font-medium-fontWeight": "700",
        "--sjs-article-font-medium-fontStyle": "normal",
        "--sjs-article-font-medium-fontStretch": "normal",
        "--sjs-article-font-medium-letterSpacing": "0",
        "--sjs-article-font-medium-lineHeight": "32px",
        "--sjs-article-font-medium-paragraphIndent": "0px",
        "--sjs-article-font-medium-textCase": "none",
        "--sjs-article-font-default-textDecoration": "none",
        "--sjs-article-font-default-fontWeight": "400",
        "--sjs-article-font-default-fontStyle": "normal",
        "--sjs-article-font-default-fontStretch": "normal",
        "--sjs-article-font-default-letterSpacing": "0",
        "--sjs-article-font-default-lineHeight": "28px",
        "--sjs-article-font-default-paragraphIndent": "0px",
        "--sjs-article-font-default-textCase": "none",
        "--sjs-general-backcolor-dim": "#F3F3F3",
        "--sjs-primary-backcolor": "#0433ff",
        "--sjs-primary-backcolor-dark": "rgba(3, 43, 216, 1)",
        "--sjs-primary-backcolor-light": "rgba(4, 46, 231, 0.1)",
        "--sjs-primary-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",
        "--sjs-special-red": "rgba(229, 10, 62, 1)",
        "--sjs-special-red-light": "rgba(229, 10, 62, 0.1)",
        "--sjs-font-surveytitle-weight": "800"
    },
    "header": {
        "height": 100
    },
    // "headerView": "basic"
}

const creatorOptions = {
    //showLogicTab: true,
    // showTranslationTab: true,
    questionTypes:
        [
            // "tagbox",
            "boolean",
            "checkbox",
            "comment",
            // "dropdown",
            // "expression",
            // "file",
            "radiogroup",
            "rating",
            // "ranking",
            // "signaturepad",
            "text",
            // "panel",
            // "paneldynamic",
            // "matrix",
            // "matrixdropdown",
            //"matrixdynamic",
            "multipletext",

            // "image"
        ],
    isAutoSave: true,
    showDesignerTab: true,
    showThemeTab: true,
    showTestSurveyTab: true, //preview tab
    showTranslationTab: false,
    showJSONEditorTab: false,
    showLogicTab: false,
};

setLicenseKey(
    "NWJmMmM2NzQtOGE3MS00ZjBjLTlkNTktMDdlMWNlZTYxYzBiOzE9MjAyNS0wOC0xNCwyPTIwMjUtMDgtMTQsND0yMDI1LTA4LTE0"
)

export const CreateCustomSurvey: React.FC<any> = (props) => {

    var jsondata = '{}'
    var editingStart = false
    const location: any = useLocation();
    const { userState } = useContext(ApplicationContext)
    const { providerState } = useContext(ProviderContext)
    const [loading, setLoading] = useState(false)
    const history = useHistory();

    const [selectedSurvey, setSelectedSurvey] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedSurveyNotes, setSelectedSurveyNotes] = useState([]);
    const [text, setText] = React.useState("");
    const [saveSurveyModal, setSaveSurveyModal] = React.useState(false);

    const labels = useTranslations()


    const creator = new SurveyCreator(creatorOptions);
    // Serializer.getProperty("boolean", "title").visible = false; //hide property
    // Serializer.getProperty("boolean", "cssClasses").visible = false; //hide property

    creator.saveSurveyFunc = (saveNo, callback) => {
        //editingStart = true
        jsondata = creator.text

        // setJsonData(creator.JSON)
        // If you use localStorage:
        window.localStorage.setItem("survey-json", creator.text);
        callback(saveNo, true);

        // If you use a web service:
        // saveSurveyJson(
        //     "https://your-web-service.com/",
        //     creator.JSON,
        //     saveNo,
        //     callback
        // );
    };
    creator.showJSONEditorTab = false
    creator.theme = themeJson;
    creator.locale = localStorage.getItem("lang");

    const toolbox = creator.toolbox;
    // Disable the compact display mode
    toolbox.forceCompact = false;

    // Change the title of the Text question type
    //toolbox.getItemByName("text").title = "Single-Line Text";

    //toolbox.removeCategories();

    creator.toolbox.getItemByName("text").removeSubitem('url')
    creator.toolbox.getItemByName("text").removeSubitem('range')
    creator.toolbox.getItemByName("text").removeSubitem('week')
    creator.toolbox.getItemByName("text").removeSubitem('password')
    //creator.toolbox.getItemByName("text")

    // const longTextItem = creator.toolbox.getItemByName("text");
    // longTextItem.addSubitem({
    //     name: "phoneNumber",
    //     title: "Limited to 11 characters",
    //     json: {
    //         type: "text",
    //         maxLength: 11
    //     }
    // });

    // const ratingItem = creator.toolbox.getItemByName("rating");
    // ratingItem.addSubitem({
    //     name: "nps",
    //     title: "Net Promoter Score",
    //     json: {
    //         "type": "rating",
    //         "rateMin": 0,
    //         "rateMax": 10
    //     }
    // });

    const singleTextInputItem = creator.toolbox.getItemByName("text");
    const telSubitem = singleTextInputItem.getSubitem("tel");
    telSubitem.json["maskType"] = "pattern";
    telSubitem.json["maskSettings"] = { "pattern": "+1(999)999-9999" };

    singleTextInputItem.json["clearIfInvisible"] = "none"

    // "maskType": "datetime",
    // "maskSettings": {
    //   "pattern": "mm/dd/yyyy HH:MM"
    // }

    const emailSubitem = singleTextInputItem.getSubitem("email");
    emailSubitem.json["validators"] = [{ "type": "email" }];

    const numberSubitem = singleTextInputItem.getSubitem("number");
    numberSubitem.json["inputType"] = "text";
    numberSubitem.json["maskType"] = "numeric";

    // numberSubitem.json["validators"] = [{ "type": "expression", "expression": "isNumberValid({number})" }, { "type": "numeric" }];
    // numberSubitem.json["validators"] = [{
    //     "type": "regex", "regex": "/^\d+$/", "text": "Invalid input"
    // }];
    // /^\d+$/
    // ^\s*[0-9]+\s*$

    useEffect(() => {
        creator.text = location?.state?.rowData && location?.state?.rowData?.jsonData
    }, [creator])


    // creator.activeTab = "theme";


    // const createForm = () => {
    //     customsurvey.title = 'Patient access information'
    //     customsurvey.pages[0].name = "Introduction to custom survey forms"
    //     customsurvey.pages[0].elements[0].type = 'text'
    //     customsurvey.pages[0].elements[0].name = 'Name'
    //     customsurvey.pages[0].elements[0].title = 'Patient Name'

    //     const surveyjs = new Model(customsurvey)
    //     console.log("🚀 ~ createForm ~ survey:--->", survey)
    //     setSurvey(surveyjs)
    // }

    //survey.css = customCss

    const handleCreateSurvey = (keepediting: boolean) => {
        if (location?.state?.rowData?.jsonData) {
            jsondata = creator.text
        }
        setLoading(true)

        const data = {
            providerId: providerState.id,
            name: location.state.rowData.surveyName,
            JsonData: jsondata,
            description: location.state.rowData.surveyDescription,
            UpdatedOn: new Date(),
            userId: userState.authenticatedUser.username,
            notes: location?.state?.rowData?.notes,
            status: keepediting ? 'Draft' : 'Under Review',
            isEditable: keepediting ? true : false
        }

        ApiService.updateSurvey(userState.authenticatedUser, data, location.state.rowData.id).then((res) => {
            setLoading(false)
            if (res.status === 200) {
                const message = keepediting ? labels.Saveasdraft : labels.SurveySubmissionUnderReview
                alert(message)
                history.push('/addSurvey')
            }
        }).catch(err => {
            setLoading(false)
            alert(labels.Somethingwentwrong)
        })
    }

    // Open sidebar with selected note
    const openSidebar = (row) => {
        setText(row?.notes)
        setIsSidebarOpen(true);
    };

    // Close sidebar
    const closeSidebar = () => {
        setText('')
        setIsSidebarOpen(false);
    };

    const handleDownloadNotes = () => {
        const base64Content = btoa(text);
        const downloadedFile = Helpers.base64ToBlob(
            base64Content,
            text
        );
        saveAs(downloadedFile);
    }

    return (
        <IonPage>
            <Header />
            <IonHeader>
                <IonToolbar color="light">
                    <IonButtons slot="start">
                        <IonBackButton
                            text={labels.Goback}
                            icon={arrowBackCircleSharp}
                            defaultHref="/"
                        />
                    </IonButtons>
                    <IonTitle>{location?.state?.rowData && location?.state?.rowData?.surveyName}</IonTitle>
                </IonToolbar>
            </IonHeader>



            <div className="commentContainer">
                {
                    location?.state?.rowData && !_.isEmpty(location?.state?.rowData?.notes) && (
                        <Icon
                            onClick={() => {
                                openSidebar(location?.state?.rowData)
                            }}
                            icon="material-symbols:comment-outline"
                            width="35"
                            height="35"
                            style={{
                                cursor: 'pointer',
                                backgroundColor: '#165fc7',
                                borderRadius: 15,
                                padding: 5,
                                color: 'white',
                                marginTop: 10,
                                marginRight: 20
                            }} />
                    )
                }
                <IonButton
                    size="default"
                    color="primary"
                    style={{ height: 50, marginRight: 30, marginTop: 10 }}
                    onClick={() => {
                        handleCreateSurvey(false)
                    }
                    }>  {labels.SubmitforReview} </IonButton>
                <IonButton
                    size="default"
                    color="primary"
                    style={{ height: 50, marginRight: 30, marginTop: 10 }}
                    onClick={() => {
                        handleCreateSurvey(true)
                    }
                    }>  {labels.Saveasdraft}  </IonButton>

            </div>

            <IonContent className="sv-property-editor">

                <SurveyCreatorComponent creator={creator} style={{ display: "box" }} />
                <IonLoading
                    cssClass="my-custom-class"
                    isOpen={loading}
                    onDidDismiss={() => setLoading(false)}
                    message={`${labels.Pleasewait}...`}
                    duration={5000}
                />
            </IonContent>

            <Dialog
                open={saveSurveyModal}
                onClose={() => setSaveSurveyModal(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {labels.DeletingSurvey}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Do you want to save the survey? Choose Keep Editing to make changes or Under Review to submit.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        handleCreateSurvey(true)
                    }}>Keep Editing</Button>
                    <Button onClick={() => {
                        handleCreateSurvey(false)
                    }} autoFocus>
                        Under Review
                    </Button>
                </DialogActions>
            </Dialog>

            <Drawer
                anchor='right'
                open={isSidebarOpen}
                onClose={() => {
                    closeSidebar()
                }}>
                <div className="container">
                    <TextareaAutosize
                        disabled={true}
                        contentEditable={false}
                        className="textArea"
                        minRows={3}
                        style={{ height: '50%' }}
                        value={text}
                    />
                    <div className="button-container">
                        <button className="close-btn" onClick={closeSidebar}>{labels.Close}</button>
                        <button className="save-btn" onClick={handleDownloadNotes}>{labels.Download}</button>
                    </div>
                </div>

            </Drawer>
        </IonPage>

    )
}